import React from "react";
import { Col, Modal, ModalFooter, Row } from "react-bootstrap";
import { Button, DropDown } from "../../../components";
import { useAppSelector } from "../../../redux/Hooks/Hook";
import { toast } from "react-toastify";


const CoachingFilterModel = (props: any) => {
  const {
    show,
    handleClose,
    handleFilterSubmit,
    sportName,
    setSportName,
    paidStatus,
    setPaymentStatus,
    coachName,
    setCoachName,
  } = props;
  const { courtBookingStatus } =
    useAppSelector((state) => state.enumsArray.Enums);
  const { AllSportsData, sportErrorMessage } = useAppSelector((state) => state.sportList);



  const { AllCoachesData, errorMessage } = useAppSelector((state) => state.coachList);


  const BookingStatusKey: string[] = Object.values(courtBookingStatus);
  const BookingStatusValues: string[] = Object.keys(courtBookingStatus);

  if (errorMessage || sportErrorMessage) {
    toast.error(errorMessage.message)
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="border-0 pb-0 pb-2" closeButton>
        <Modal.Title id="contained-modal-title-vcenter fw-semibold">
          Filter
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col lg={6}>
            <div className="mb-3">
              <label htmlFor="pstatus" className="form-label">
                Status
              </label>
              <DropDown
                id="pstatus"
                name="pstatus"
                value={paidStatus}
                onChange={(e: any) => setPaymentStatus(e.target.value)}
              >
                <option value="">Select Status</option>
                {BookingStatusKey?.map((item: string, index: number) => {
                  return (
                    <option
                      key={BookingStatusValues[index]}
                      value={BookingStatusValues[index]}
                    >
                      {item === "Ongoing" ? "Running" : item}
                    </option>
                  );
                })}
              </DropDown>
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <label htmlFor="sports" className="form-label">
                SportName
              </label>
              <DropDown
                id="sports"
                name="sports"
                value={sportName}
                onChange={(e: any) => setSportName(e.target.value)}
              >
                <option value="">Select Sport</option>
                {AllSportsData?.map((item: any) => {
                  return (
                    <option key={`${item.id}`} value={`${item.id}`}>
                      {item.name}
                    </option>
                  );
                })}
              </DropDown>
            </div>
          </Col>
          <Col lg={6}>
            <div className="mb-3">
              <label htmlFor="coach" className="form-label">
                CoachName
              </label>
              <DropDown
                id="coach"
                name="coach"
                value={coachName}
                onChange={(e: any) => setCoachName(e.target.value)}
              >
                <option value="">Select Coach</option>
                {AllCoachesData?.map((item) => {
                  return (
                    <option key={`${item.id}`} value={`${item.id}`}>
                      {item.fullName}
                    </option>
                  );
                })}
              </DropDown>
            </div>
          </Col>
        </Row>
        <ModalFooter>
          <Col lg={12} className="text-center">
            <Button
              onClick={handleFilterSubmit}
              type="button"
              bname="Submit"
              name="submit"
              id="submit"
              className="btn btn-primary rounded-1 mt-1"
            ></Button>
          </Col>
        </ModalFooter>
      </Modal.Body>
    </Modal>
  );
};

export { CoachingFilterModel };
